﻿(function (w, d, $) {
    $(document).ready(function () {
        $(".tag").each(function () {
            $(this).click(function (e) {
                e.preventDefault();
                $(this).toggleClass("active");
            });
        });
    });
})(window, document, jQuery);